import { router } from '@inertiajs/vue3'
import { routing } from '@/Support/Routing/Functions/routing'

/**
 * Sends the user to the in-app billing screen, where plans are picked.
 */
export const visitBilling = () => router.visit(routing('settings.billing'))

/**
 * Sends the user to the Stripe hosted billing portal, which handles
 * payment methods, invoices and cancellations. The route answers with a
 * redirect to Stripe, so this is a plain browser navigation rather than an
 * Inertia visit.
 */
export const visitBillingPortal = () => {
  window.location.href = routing('settings.billing.portal')
}
